import React from 'react';
import { lighten, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  link: {
    color: '#004AD6',
    textDecoration: 'underline',
    '&:hover': {
      color: lighten('#004AD6', 0.4),
    },
  },
}));

const Link = ({ href, children, className, ...rest }) => {
  const classes = useStyles();
  return (
    <a href={href} className={clsx(classes.link, className)} {...rest}>
      {children}
    </a>
  );
};

export default Link;
